import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect /admin to /admin/staff (admin landing page)
export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/staff' });
  },
});
